var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "#C1C7D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.452 21.2291C6.11004 21.2291 2.81972 17.4696 2.81972 12.6952C2.79691 10.1628 3.80307 7.7297 5.60773 5.95306C7.41239 4.17643 9.86096 3.20848 12.3926 3.27091C17.2654 3.27091 20.9018 6.26394 20.9018 10.9888C20.9018 15.2926 18.6264 16.9997 16.3503 16.9997C15.3738 17.0508 14.4467 16.5675 13.9294 15.7377C13.1021 16.5075 12.0168 16.94 10.8868 16.9501C8.16552 16.9501 6.78359 15.0208 6.78359 12.6921C6.73728 11.2501 7.28616 9.85264 8.30137 8.82761C9.31658 7.80258 10.7087 7.24029 12.1511 7.27272C12.9461 7.24779 13.7277 7.48231 14.3777 7.94085L14.4767 7.52046H16.8264L15.6651 12.9623C15.4422 14.0508 15.6899 14.9163 16.7537 14.9163C18.0644 14.9163 18.8316 13.8278 18.8316 10.9339C18.8316 7.0753 15.789 5.2691 12.3756 5.2691C10.391 5.19802 8.46687 5.95869 7.06737 7.36759C5.66787 8.7765 4.92011 10.7057 5.00449 12.6897C5.00449 16.5979 7.50281 19.1457 11.4605 19.1457C12.9714 19.1573 14.4635 18.8097 15.8138 18.1316L16.6298 20.1352C14.9925 20.8365 13.233 21.2082 11.452 21.2291ZM11.2786 14.6244C11.9498 14.6504 12.6024 14.3999 13.084 13.9315L13.8752 10.2704C13.425 9.81792 12.8102 9.56783 12.172 9.57747C11.4046 9.57036 10.6681 9.87891 10.1349 10.4308C9.60169 10.9827 9.31876 11.7295 9.35236 12.4962C9.35004 13.7837 9.96862 14.6244 11.2793 14.6244H11.2786Z",
    fill: "#C1C7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e98cba18f98b8ef1b815520c905a470a.svg";
export { ForwardRef as ReactComponent };